<template>
    <div>
        <div class="has-text-weight-bold mb-2">
            {{ translateRule(rule) }}
        </div>
        <div>
            <span class="icon">
                <i class="fas fa-chart-bar"></i>
            </span>
            <span>
                {{ translate("page.admin_academy_results.points_awarded_for_each_match_won") }}
                {{ ruleArguments.pointsForWinning }}
            </span>
        </div>
        <div>
            <span class="icon">
                <i v-if="ruleArguments.multiplierForSubmissionWin" class="has-text-success fa fa-check-circle" />
                <i v-else class="has-text-danger fa fa-times-circle" />
            </span>
            <span>
                {{ translate("event_ranking.rule.promoteSubmission") }}
                <template v-if="ruleArguments.multiplierForSubmissionWin"> ({{ ruleArguments.multiplierForSubmissionWin }}x) </template>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { AwardPointsForWinArguments, translateRule } from "../CalculationRules/types";
    import { translate } from "../../Common/translations";

    defineProps<{
        rule: string;
        ruleArguments: AwardPointsForWinArguments;
    }>();
</script>

<style scoped></style>
